import {
  DEVICE_DETAILS_FETCH_STARTED,
  DEVICE_DETAILS_FETCH_SUCCEEDED,
  DEVICE_DETAILS_FETCH_FAILED,
  DEVICE_DETAILS_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  device: {},
  status: statuses.idle
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case DEVICE_DETAILS_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case DEVICE_DETAILS_FETCH_SUCCEEDED:
      return {
        ...state,
        device: action.payload
      };
    case DEVICE_DETAILS_FETCH_FAILED:
      return { ...state, status: statuses.failed, error: action.error };
    case DEVICE_DETAILS_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
